export default {"src":"/org/_next/static/media/location.3e87cb2e.svg","height":16,"width":12,"blurWidth":0,"blurHeight":0};